// extracted by mini-css-extract-plugin
module.exports = {"buttons":"question_body_buttons__Y8ySd","questionBody":"question_body_questionBody__sMZMH","ref":"question_body_ref__39kuS"};